import * as React from 'react';
import * as s from '../responsive.scss';
import * as classNames from 'classnames';
export var ShowOnDesktopOnly = function (props) {
    var classes = classNames(s.desktopOnly, props.className);
    return React.createElement("div", { className: classes }, props.children);
};
//# sourceMappingURL=ShowOnDesktopOnly.js.map